import { rem, rgba, size } from "polished";
import styled, { css } from "styled-components";
import media from "styled-media-query";

import { themes } from "styles";

import { IBadgeProps } from "./interfaces";

export const Container = styled.div<IBadgeProps>`
  padding: 6px 10px;

  display: inline-flex;
  align-items: center;

  font-weight: 600;
  border-radius: 6px;
  font-size: ${rem("7px")};

  ${media.greaterThan("large")`
    font-size: ${rem("8px")};
  `}

  ${media.greaterThan("huge")`
    padding: 8px 16px;

    border-radius: 8px;
    font-size: ${rem("12px")};
  `}

  ${(props) =>
    !props.removeDot &&
    css`
      &:before {
        ${size("4px")}

        margin-right: 4px;

        content: "";

        border-radius: 100%;

        ${media.greaterThan("huge")`
          ${size("6px")}

          margin-right: 6px;
        `}
      }
    `}

  ${(props) =>
    props.kind &&
    {
      info: css`
        color: ${themes.palletes.info};
        background-color: ${rgba(themes.palletes.info, 0.1)};

        &:before {
          background-color: ${themes.palletes.info};
        }
      `,

      success: css`
        color: ${themes.palletes.success};
        background-color: ${rgba(themes.palletes.success, 0.1)};

        &:before {
          background-color: ${themes.palletes.success};
        }
      `,

      warning: css`
        color: ${themes.palletes.warning};
        background-color: ${rgba(themes.palletes.warning, 0.1)};

        &:before {
          background-color: ${themes.palletes.warning};
        }
      `,

      danger: css`
        color: ${themes.palletes.danger};
        background-color: ${rgba(themes.palletes.danger, 0.1)};

        &:before {
          background-color: ${themes.palletes.danger};
        }
      `,
    }[props.kind]}
`;
